import { Box, styled } from '@mui/material';

/** 레거시 마크업 class 보충 */
export const SapBudgetIncreaseRoot = styled(Box)`
  /* 공통 표의 break-all 보다 우선해야 영문 부서명·머리글이 단어 중간에서 안 끊김 */
  & .approval-form-table th,
  & .approval-form-table td {
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
  & .d-none {
    display: none;
  }
  & .text-center {
    text-align: center;
  }
  & .text-right {
    text-align: right;
  }
`;
